<template>
  <v-container>
    <mensajeSistema></mensajeSistema>

    <!-- filter -->
    <v-row>
      <v-col cols="12" md="3">
        <AutocompleteComp @change="change_anio()" :items="anio_lectivo" v-model="filter.id_anio_lectivo"
          item-text="nom_anolectivo" item-value="id" text-label="Año lectivo" />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteComp @change="change_incidencia()" :items="filter.incidencias" v-model="filter.id_tipo_incidencia"
          item-text="descripcion" item-value="id" text-label="Tipo de incidencia" />
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-end align-center">
        <ButtonComp @click="crear()" icon-but="fas fa-plus" text-button="Crear papeleta" normal-button />
      </v-col>

      <v-col cols="12">
        <ComundataTablecomp :headers="Papeletaheaders" :items="desserts">

          <template v-slot:editar="{ item }">
            <ButtonComp @click="on_update(item)" edit-button tooltip-text="Editar papeleta" />
          </template>

          <template v-slot:eliminar="{ item }">
            <ButtonComp @click="on_delete(item)" delete-button tooltip-text="Eliminar papeleta" />
          </template>
        </ComundataTablecomp>
      </v-col>

    </v-row>
    <!-- type: 1->guardar, 2-> actualizar, 3-> eliminar -->
    <GlobalDialog v-if="confirm.type == 1" Deletedialog v-model="confirm.active" @close-modal="confirm.active = false"
      @delete-item="registrar(true)" @cancel-item="registrar(false)">
      <template v-slot:body>
        <h2 class="font-font-weight-bold text-center">
          {{ confirm.title }}
        </h2>
      </template>
    </GlobalDialog>

    <GlobalDialog v-else-if="confirm.type == 2" Deletedialog v-model="confirm.active" titleWindow="Eliminar papeleta"
      @close-modal="confirm.active = false" @delete-item="deleted(true)" @cancel-item="confirm.active = false">
      <template v-slot:body>

        {{ confirm.title }}
      </template>
    </GlobalDialog>

    <!-- create & updated form -->
    <v-row justify="center">

      <v-form ref="formDatos" lazy-validation class="card white pb-3">

        <!-- global dialog -->
        <GlobalDialog :title="dialog.title" @close-modal="dialog.active = false" v-model="dialog.active" maxWidth="1000">
          <template v-slot:body>
            <v-row>
              <v-col cols="12" sm="12" class="column">
                <v-text-field label="Año lectivo" v-model="setreg.anio_lectivo" readonly></v-text-field>
              </v-col>

              <v-col class="d-flex column" cols="12" sm="5">
                <v-select :items="incidencias" v-model="setreg.id_tipo_incidencia" item-text="descripcion" item-value="id"
                  label="Tipo de incidencia" :rules="[rules.selectReq]"></v-select>
              </v-col>

              <v-col cols="12" sm="7" class="column">
                <v-text-field label="Tipo de papeleta" v-model="setreg.tipo_papeleta"
                  :rules="[rules.required]"></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" class="column">
                <v-text-field v-model="setreg.puntaje" label="Puntaje" type="text"
                  :rules="[rules.required, rules.maxPuntaje]" @keypress="restrictCharsNumeros($event)"></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" class="column mt-6">
                <v-row>
                  <v-col cols="4" class="leyenda">
                    <div class="border d-flex">
                      <p class="title">Leyenda:</p>
                      <p class="content">
                        <span> Mérito: (+) </span>
                        <span> Demérito: (-) </span>
                      </p>

                    </div>
                  </v-col>
                  <v-col cols="8" class="leyenda">
                    <div class="border d-flex">
                      <p class="title">Puntaje:</p>
                      <ul style="list-style: decimal;">
                        <li style="display: inline-block;"><strong>AD:</strong> 4 pts</li>
                        <li style="display: inline-block; margin-left: 25px;"><strong>A:</strong> 3 pts</li>
                        <li style="display: inline-block; margin-left: 25px;"><strong>B:</strong> 2 pts</li>
                        <li style="display: inline-block; margin-left: 25px;"><strong>C:</strong> 1 pts</li>
                      </ul>

                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template v-slot:actions>
            <v-spacer></v-spacer>

            <ButtonComp v-if="dialog.update" @click="actualizar()" textButton="Guardar cambios" iconBut="fas fa-save"
              :loading="dialog.animated" normalButton>
            </ButtonComp>

            <ButtonComp v-else @click="on_save()" textButton="Guardar" iconBut="fas fa-save" :loading="dialog.animated"
              normalButton>
            </ButtonComp>
          </template>
        </GlobalDialog>
      </v-form>

    </v-row>


  </v-container>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapActions } from "vuex";
import GlobalDialog from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import { Papeletaheaders } from '../../../../helpers/headersTable';



export default {
  name: "CriterioPapeleta",
  components: {
    GlobalDialog,
    ButtonComp,
    AutocompleteComp,
    ComundataTablecomp,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Campo requerido",
        selectReq: (value) =>
          !!value || "Debe seleccionar un campo de la lista",
        maxPuntaje: (v) => (v) <= 4 || "Numeros permitidos del 1 al 4",
        max2: (v) => (v || "").length <= 2 || "Máximo 2 digitos",
      },
      Papeletaheaders,
      dialog: {
        active: false,
        confirm: false,
        title: "",
        animated: false,
        isValid: true,
        update: false,
      },
      confirm: {
        active: false,
        state: false,
        title: "",
        type: 0,
      },

      desserts: [],
      setreg: {
        id: 0,
        anio_lectivo: "",
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_tipo_incidencia: 0,
        tipo_papeleta: "",
        puntaje: 0,
        id_usu: sessionStorage.id,
      },
      storage: sessionStorage,
      filter: {
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
        id_tipo_incidencia: 0,
        incidencias: [],
      },
      parameters: {
        id_colegio: sessionStorage.id_colegio,
        id_incidencia: 0,
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
        id_usu: sessionStorage.id,
      },
      anio_lectivo: [],
      incidencias: [],
    };
  },
  mounted() {
    this.resetForm();
  },
  created() {
    this.ano_lectivo();
    this.tipo_incidencia();
    this.initialData();
    this.resetForm();
  },
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.resetForm();
      }
    },
  },
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    async initialData() {
      console.log("RespuestaR", this.filter)
      try {
        await axios
          .post(`/administrativo/manualidades/papeletas/`, {
            id_ano_lectivo: this.filter.id_anio_lectivo,
            id_tipo_incidencia: this.filter.id_tipo_incidencia,
          })
          .then((response) => {
            this.desserts = response.data;
          });
      } catch (e) {
        console.log("Error al cargar la data inicial", e);
      }
    },
    // listar año lectivo
    async ano_lectivo() {
      try {
        const response = await axios.get(
          `/administrativo/manualidades/criterios/anolectivo/${this.parameters.id_colegio}`
        );
        this.filter.id_anio_lectivo = response.data[0].id;
        this.setreg.anio_lectivo = response.data[0].nom_anolectivo;
        this.anio_lectivo = response.data;
      } catch (e) {
        console.log("Error al solicitar el año lectivo", e);
      }
    },
    async tipo_incidencia() {
      await axios
        .get("/administrativo/manualidades/incidencias/tipo/")
        .then((response) => {
          this.filter.incidencias = response.data;
          if (response.data.length > 0) {
            this.filter.incidencias.unshift({ id: 0, descripcion: "Todos" });
          } else {
            this.filter.incidencias.push({ id: 0, descripcion: "Todos" });
          }
          this.incidencias = [...response.data];
          this.incidencias.splice(0, 1);
        });
    },
    restrictCharsNumeros: function ($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    clear() {
      this.setreg.id = "";
      this.setreg.id_ano_lectivo = sessionStorage.id_ano_lectivo;
      this.setreg.id_tipo_incidencia = 0;
      this.setreg.tipo_papeleta = "";
      this.setreg.puntaje = "";
      this.setreg.id_usu = sessionStorage.id;
      //this.dialog.active = false;
      this.dialog.update = false;
      this.confirm.active = false;
      this.confirm.type = 0;
      this.confirm.title = "";
      this.resetForm();
    },
    resetForm() {
      if (this.$refs.formDatos != undefined) {
        this.$refs.formDatos.resetValidation();
      }
    },
    crear(active = false) {
      this.clear();
      this.dialog.title = "Crear papeleta";
      this.dialog.active = active ? active : !this.dialog.active;
    },

    // filtros listado
    change_incidencia() {
      setTimeout(() => {
        this.initialData();
      }, 100);
    },
    change_anio() {
      this.tipo_incidencia();
      setTimeout(() => {
        this.initialData();
      }, 100);
    },
    // on change event
    on_save() {
      if (this.$refs.formDatos.validate()) {
        this.confirm.active = true;
        this.confirm.type = 1;
        this.confirm.title = " ¿Desea registrar otra papeleta?";
      }
    },
    async on_update(item) {
      try {
        await axios
          .post(`/administrativo/manualidades/papeletas/${item.id}`, {
            id_ano_lectivo: this.filter.id_anio_lectivo,
          })
          .then((response) => {
            const { data } = response;
            this.setreg.id = data.id;
            this.dialog.title = "Editar papeleta";
            //this.anio_lectivo = "";
            this.setreg.id_ano_lectivo = data.id_ano_lectivo;
            this.setreg.id_tipo_incidencia = data.id_tipo_incidencia;
            this.setreg.tipo_papeleta = data.tipo_papeleta;
            this.setreg.puntaje = data.puntaje;

            this.dialog.active = true;
            this.dialog.update = true;
            this.resetForm();
          });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: "Error al obtener registro", tiempo: null });
      }
    },
    on_delete(item) {
      this.clear();
      this.confirm.active = true;
      this.confirm.type = 2;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.setreg.id = item.id;
    },

    // acciones registrar, actualizar, eliminar
    async registrar(state = false) {
      await axios
        .post("/administrativo/manualidades/papeletas/create/", this.setreg)
        .then((response) => {
          if (state) {
            this.confirm.active = false;
            this.dialog.active = true;
          } else {
            this.confirm.active = false;
            this.dialog.active = false;
          }
          this.confirm.type = 0;
          this.confirm.title = "";
          this.clear();
          this.initialData();

          const { data } = response;
          if (data.success) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: data.message,
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: data.message,
              tiempo: null,
            });
          }
        });
    },
    async actualizar() {
      if (this.$refs.formDatos.validate()) {
        await axios
          .put(
            `/administrativo/manualidades/papeletas/${this.setreg.id}`,
            this.setreg
          )
          .then((response) => {
            const { data } = response;
            if (data.success) {
              this.setEnviarMens({
                tipo: "S",
                mensaje: data.message,
                tiempo: null,
              });
              this.confirm.active = false;
              this.dialog.active = false;
              this.confirm.type = 0;
              this.confirm.title = "";
              this.setreg.id = 0;
              this.clear();
            } else {
              this.setEnviarMens({
                tipo: "E",
                mensaje: data.message,
                tiempo: null,
              });
            }
            this.initialData();
          });
      }
    },
    async deleted() {
      await axios
        .post(`/administrativo/manualidades/papeletas/delete/${this.setreg.id}`)
        .then((response) => {
          const { data } = response;

          if (data.success) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: data.message,
              tiempo: null,
            });
            this.confirm.active = false;
            this.dialog.active = false;
            this.confirm.type = 0;
            this.confirm.title = "";
            this.setreg.id = 0;

            this.clear();
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: data.message,
              tiempo: null,
            });
          }
          this.initialData();
        });
    },
  },
};
</script>
<style>
.leyenda .border {
  border: 0.5px solid grey;
  padding: 0.5rem;
  padding-left: 0.5rem;
  flex-direction: column;
  /* position: relative; */
}

.leyenda .title {
  font-weight: 700;
  display: block;
  margin: 0px;
  margin-top: -20px;
  padding-left: 0.5rem;
  padding-right: 1rem;
  width: fit-content;
  background: white;
}

.leyenda .content {
  padding-left: 0.5rem;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  font-weight: 500;
}

.column {
  padding: 5px 12px !important;
}
</style>